/**
 * Tilts a playing card towards the pointer, so it lifts off the table (.card-tilt in base.css).
 * Listens on the document, so cards added later (product recommendations) tilt as well.
 */
if (!window.cardTilt) {
  window.cardTilt = true;
  let current = null;

  const reset = () => {
    if (!current) return;
    current.style.removeProperty('--pointer-x');
    current.style.removeProperty('--pointer-y');
    current = null;
  };

  document.addEventListener('pointermove', (event) => {
    // Touch has no hover.
    if (event.pointerType !== 'mouse') {
      return;
    }
    const card = event.target instanceof Element ? event.target.closest('.card-tilt') : null;
    if (card !== current) reset();
    if (!card) return;
    current = card;
    // From -1 (left, top) to 1 (right, bottom).
    const box = card.getBoundingClientRect();
    const x = ((event.clientX - box.left) / box.width) * 2 - 1;
    const y = ((event.clientY - box.top) / box.height) * 2 - 1;
    card.style.setProperty('--pointer-x', Math.max(-1, Math.min(1, x)).toFixed(3));
    card.style.setProperty('--pointer-y', Math.max(-1, Math.min(1, y)).toFixed(3));
  });

  document.addEventListener('pointerleave', reset);
}
